import React from 'react';
import { connect } from 'react-redux';
import { configureActions } from '../../../../../actions/configure.action';
import { Alert } from '../../../../UI/Common';
import Datagrid from '../../../../UI/Datagrid';

function EffectedSensors({ sensorTypeId, ...props }) {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [err, setErr] = React.useState('');
  React.useEffect(() => {
    setLoading(true);
    props
      .getSensorsBySensorType(sensorTypeId)
      .then((resp) => setData(resp))
      .catch((error) => setErr(error))
      .finally(() => setLoading(false));
  }, [sensorTypeId]);
  const columns = [
    {
      dataField: 'groupName',
      text: 'Group Name',
      sort: true,
    },
    {
      dataField: 'name',
      text: 'Sensor Name',
      sort: true,
    },
    {
      dataField: 'location',
      text: 'Location',
      sort: true,
    },
    {
      dataField: 'serialNo',
      text: 'Serial',
      sort: true,
    },
  ];
  return (
    <>
      <Alert.Error text={err} />
      <Datagrid
        noSearch
        noPagination
        noExport
        datagridProps={{ keyField: 'name', columns, data, loading }}
      />
    </>
  );
}

export default connect(null, configureActions)(EffectedSensors);
